var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "28px",
    viewBox: "0 0 16 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "985CF007-01DF-4CE4-AB2A-ED63BA042EB4@1.50x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BMW",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Profile",
    transform: "translate(-24.000000, -32.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multimedia-option",
    transform: "translate(24.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.38526897,13.5781517 L15.5400828,3.42289655 C15.8196966,3.14394483 15.9735172,2.77097931 15.9735172,2.37329655 C15.9735172,1.9753931 15.8196966,1.60264828 15.5400828,1.32325517 L14.6502621,0.433875862 C14.3710897,0.154041379 13.9979034,0 13.6002207,0 C13.2025379,0 12.8297931,0.154041379 12.5504,0.433875862 L0.459475862,12.5245793 C0.17897931,12.8048552 0.0253793103,13.1793655 0.0264768461,13.5774897 C0.0253793103,13.9773793 0.178758621,14.3514483 0.459475862,14.6319448 L12.5391448,26.7109517 C12.8185379,26.9907862 13.1912828,27.1448276 13.5891862,27.1448276 C13.986869,27.1448276 14.3596138,26.9907862 14.6392276,26.7109517 L15.5288276,25.8215724 C16.1076966,25.2427034 16.1076966,24.3003586 15.5288276,23.7217103 L5.38526897,13.5781517 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevron);
export default __webpack_public_path__ + "static/media/icon_chevron.3fd023b9b0919c635b33408ebc943cb8.svg";
export { ForwardRef as ReactComponent };